import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { LineReveal, Reveal } from "@/components/Reveal";

export const PageHero = ({ eyebrow, title, lines, intro, crumb, children }) => (
  <section className="relative overflow-hidden bg-night pb-16 pt-32 text-white sm:pb-20 sm:pt-40 grain">
    <div className="absolute inset-0 grid-lines" aria-hidden="true" />
    <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-slate/40 blur-3xl" aria-hidden="true" />
    <div className="container-x relative">
      {crumb && (
        <nav aria-label="Fil d'Ariane" className="mb-8 flex items-center gap-2 text-xs text-white/50" data-testid="breadcrumb">
          <Link to="/" className="hover:text-gold">Accueil</Link>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="text-white/80">{crumb}</span>
        </nav>
      )}
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h1 className="h-display mt-5 max-w-4xl" data-testid="page-title">
        {lines ? <LineReveal lines={lines} /> : title}
      </h1>
      {intro && (
        <Reveal delay={0.3}>
          <p className="lede mt-6 max-w-2xl !text-white/70">{intro}</p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);
